import React from 'react'
import { Link } from 'react-router-dom'

const CTA = ({
  children,
  tag: Tag = 'button',
  buttonType = 'button',
  type = 'block-primary',
  target = '',
  className = '',
  onClick = () => {},
  wtData = {},
  wtDisable = false,
  ...props
}) => {
  const handleClick = event => {
    if (!wtDisable) {
      const ctaURL = props.href || props.to
      window._wt({
        category: `CTA-${Tag === 'button' ? 'button' : 'link'}`,
        action: 'click',
        values: ctaURL
          ? [
              {
                type: 'url',
                value: /http|mailto/.test(ctaURL)
                  ? ctaURL
                  : `${window.location.origin}${ctaURL}`
              },
              { type: 'text', value: event.target.textContent.trim() }
            ]
          : [
              {
                type: 'text',
                value:
                  type === 'icon'
                    ? '(ICON)'
                    : event.target.textContent.trim() || '(ICON)'
              }
            ],
        ...(wtData['CTA-click'] ? wtData['CTA-click'] : {})
      })
    }

    if (onClick) onClick(event)
  }

  if (wtData['CTA-click']) {
    if (wtData['CTA-click'].label) {
      props['data-wtlab'] = wtData['CTA-click'].label
    }

    if (wtData['CTA-click'].location) {
      props['data-wtloc'] = wtData['CTA-click'].location
    }
  }

  if (Tag === 'Link') {
    // Necessary because React can't dynamically render components based on strings
    return (
      <Link
        className={`CTA-${type} ${className ? className : ''}`}
        aria-label={typeof children === 'string' ? children : 'button'}
        onClick={handleClick}
        {...props}>
        {children}
      </Link>
    )
  }
  return (
    <Tag
      className={`CTA-${type} ${className ? className : ''}`}
      type={Tag === 'button' ? buttonType : undefined}
      aria-label={typeof children === 'string' ? children : 'button'}
      target={Tag === 'a' ? target : undefined}
      onClick={handleClick}
      {...props}>
      {children}
    </Tag>
  )
}

export default CTA
